import PrivacyPolicyPage from './PrivacyPolicyPage';

export default PrivacyPolicyPage;
